import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=05be62b2&scoped=true&"
import script from "./ScrollBar.vue?vue&type=script&lang=js&"
export * from "./ScrollBar.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ScrollBar.vue?vue&type=style&index=1&id=05be62b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be62b2",
  null
  
)

export default component.exports